import React, { Component } from 'react'
import { message } from 'antd'
import { get, pick } from 'lodash'
import Members from '../../../../../../../api/Members'
import ContractsApi from '../../../../../../../api/People/LabourContracts'
import Employees from '../../../../../../../api/Employees'
import { execute } from '../../../../../../../modules/Utils'
import DocumentsApi from '../../../../../../../api/Documents'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import ViewWorkOrders from './ViewWorkOrders'

class ViewWorkOrdersCont extends Component {
  constructor(props) {
    super(props)
    this.state = {
      created: false,
      id: props.match.params.key,
      workOrderKey: get(props.match, 'params.workOrderKey'),
      contractKey: get(props.match, 'params.contractKey'),
      submitting: false,
      fetching: false,
      employeeFetching: false,
      linesList: [],
      actions: [],
      member: {},
      contract: {},
      employee: {},
      workOrder: {},
      updatingState: false,
    }
    this.contractsApi = new ContractsApi()
    this.api = new Employees()
    this.memberApi = new Members()
    this.docsApi = new DocumentsApi()
  }

  overviewCmpRef = React.createRef()
  keyTermsCmpRef = React.createRef()
  payrollCmpRef = React.createRef()
  communicationCmpRef = React.createRef()

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const employeeResponse = await this.api.getMember(this.state.id)
      const memberResponse = await this.memberApi.get(this.state.id)
      let workOrder = await this.contractsApi.workOrder.get(this.state.workOrderKey)
      let contract = await this.contractsApi.get(this.state.contractKey)
      const actions = await this.docsApi.actions('labourContracts', workOrder.status)
      let member = await memberResponse.json()
      let employee = await employeeResponse.json()
      this.setState({
        member,
        employee,
        contract,
        workOrder,
        actions,
        fetching: false,
        employeeFetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
        employeeFetching: false,
      })
    }
  }
  handleOps = async (operation, workOrder) => {
    const { submit, revise, cancel, remove, reject, approve, close } = this.contractsApi.workOrder
    const { employee, member } = this.state
    const { history } = this.props
    switch (operation) {
      case 'default':
        await execute(this, this.contractsApi.default.set.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'revise':
        await execute(this, revise.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'update':
        history.push({
          pathname: `update`,
        })
        break

      case 'submit':
        await execute(this, submit.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'approve':
        await execute(this, approve.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'cancel':
        await execute(this, cancel.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'remove':
        await execute(this, remove.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        history.replace({
          pathname: `people/member/${member._key}/`,
          state: { workOrder, employee, member },
        })
        break

      case 'reject':
        await execute(this, reject.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'close':
        await execute(this, close.bind(this, pick(workOrder, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
    }
  }

  render() {
    return (
      <ViewWorkOrders
        {...this.state}
        {...pick(this, [
          'fetch',
          'handleOps',
          'overviewCmpRef',
          'keyTermsCmpRef',
          'payrollCmpRef',
          'communicationCmpRef',
        ])}
      />
    )
  }
}

export default compose(withRouter)(ViewWorkOrdersCont)
